import { type EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { type NgxMaskConfig, NgxMaskPipe, provideEnvironmentNgxMask } from 'ngx-mask';

export function provideMask(config?: Partial<NgxMaskConfig>): EnvironmentProviders {
  return makeEnvironmentProviders([provideEnvironmentNgxMask(config), NgxMaskPipe]);
}
